<template>
  <div 
    v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
    ref="bienvenidaRef"
    class="bienvenida-overlay"
  >
    <div ref="contenidoRef" class="overlay-content">

      <!-- Franja superior -->
      <div class="franja-superior">
        <span ref="tituloRef" class="titulo-pase">RSVP</span>
      </div>

      <!-- Nombre -->
      <div ref="textoRef" class="welcome-text">
        {{ welcomeText }}
      </div>

      <!-- Mensaje -->
      <div ref="mensajeRef" class="mensaje-bienvenida">
        Para nosotros sería un honor contar con tu presencia en este día tan especial donde celebro mis XV.
      </div>

      <!-- Info -->
      <div class="info-container">
        <div v-if="(paquete === 3 || paquete === 4) && numpase" ref="paseRef" class="info-item">
          <span>PASES: {{ numpase }}</span>
        </div>
        <div v-if="paquete === 4 && mesaText" ref="mesaRef" class="info-item">
          <span>MESA: {{ mesaText }}</span>
        </div>
      </div>
    </div>

    <div v-show="showTooltip" ref="tooltipRef" class="tooltip">
      ¡Recuerda confirmar asistencia!
    </div>
  </div>
</template>
<script>
import { ref, onMounted, nextTick, computed, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import axios from 'axios'
import baseUrl from '../api'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'InvitadoEvento',
  props: {
    idInvitado: Number,
    nombre: String,
    idFestejado: Number
  },
  setup(props) {
    const bienvenidaRef = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const mensajeRef = ref(null)
    const paseRef = ref(null)
    const mesaRef = ref(null)
    const tooltipRef = ref(null)

    const welcomeText = ref('')
    const mesaText = ref('')
    const numpase = ref(null)
    const paquete = ref(null)
    const showTooltip = ref(false)

    const isValidIdInvitado = computed(
      () => !isNaN(props.idInvitado) && props.idInvitado > 0
    )

    const fetchData = async () => {
      if (!isValidIdInvitado.value) return
      const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${props.idInvitado}`
      const { data } = await axios.get(url)
      welcomeText.value = data.nombre_mostrar
      mesaText.value = data.num_mesa
      numpase.value = data.num_pase
      paquete.value = data.paquete
    }

    const animateElements = () => {
      const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

      // 📝 TEXTO
      tl.fromTo(
        [tituloRef.value, textoRef.value, mensajeRef.value],
        { autoAlpha: 0, y: 20 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.12
        }
      )

      // 🎟 INFO
      tl.fromTo(
        [paseRef.value, mesaRef.value],
        { autoAlpha: 0, y: 16 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.35,
          stagger: 0.1
        },
        '>-0.05'
      )

      // 🔔 TOOLTIP (al final)
      if (tooltipRef.value) {
        gsap.fromTo(
          tooltipRef.value,
          { autoAlpha: 0, y: -12, scale: 0.9 },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.9,
            ease: 'elastic.out(1,0.6)'
          }
        )
      }
    }

    onMounted(async () => {
      await fetchData()
      await nextTick()

      ScrollTrigger.create({
        trigger: bienvenidaRef.value,
        start: 'top 90%',   // 🔥 entra rápido al viewport
        once: true,
        onEnter: () => {
          showTooltip.value = true
          animateElements()
        }
      })
    })

    onBeforeUnmount(() => ScrollTrigger.kill())

    return {
      bienvenidaRef,
      tituloRef,
      textoRef,
      mensajeRef,
      paseRef,
      mesaRef,
      tooltipRef,
      welcomeText,
      mesaText,
      numpase,
      paquete,
      showTooltip
    }
  }
}
</script>


<style scoped>
.bienvenida-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #fff;
    background: #ffffff;
  overflow: visible;
z-index:99;
  background-size: cover;
  background-position: center;
  min-height: 50vh;
  background-size: cover;
  perspective: 1000px;
  padding: 10px 10px;
}

.overlay-content {
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  width: 450px;
  transform-style: preserve-3d;
  transition: transform 0.3s ease;
  position: relative;
}

.titulo-pase {
 font-size: 62px ! important; /* Ajusta el tamaño de la fuente */
  font-family: "titulos", cursive; 
  color: #a4bcac;
  ;  font-size: 43px;
  display: block;
  margin-top: 15px;
}

.welcome-text {
  font-size: 1.4rem;
  font-family: 'quote', serif; /* o tu fuente real 'fa' si está bien definida */
  color: #1a1a1a;
  margin-top: 10px;
  margin-bottom: 5px;
  letter-spacing: 0px; /* 👈 elimina el espaciado extra */
  margin: 15px 0 10px;
}

.mensaje-bienvenida {
  font-size: 1rem;
  font-family: 'padres';
  color: #050505;
  margin-top: 10px;
}

.info-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #171717;
  font-family: 'padres';
}

.info-item i {
  margin-right: 8px;
  font-size: 1.2rem;
}

.tooltip {
  position: absolute;
  bottom: 0px;
  background: #a4bcac;
  color: white;
  padding: 0px 15px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ornamento-arriba,
.ornamento-abajo {
  position: absolute;
  width: 40%;
  height: auto;
  right: -50px;               /* ✅ alineado a la derecha */
  top: -120px;                 /* o ajusta según quieras: top / bottom */
  transform: translateY(-20%); /* puedes ajustar visualmente */
  opacity: 0.9;
  z-index:99;

}

.flor-1 {
  position: absolute;
    transform: translateY(-20%); /* puedes ajustar visualmente */

 width: 100px;
  height: 100px;  left: -50px;               /* ✅ alineado a la derecha */
  top: -60px;                 /* o ajusta según quieras: top / bottom */
  opacity: 0.9;
z-index:99;
}
.flor-2 {
  position: absolute;
  width: 100px;
  height: 100px;

  right: -50px;               /* ✅ alineado a la derecha */
  top: -60px;                 /* o ajusta según quieras: top / bottom */
  opacity: 0.9;
z-index:99;
}


.rama-der-baja5{
  position: absolute;      /* 🔥 CLAVE */
  top: -60px;                 /* o ajusta según quieras: top / bottom */
  right: -70px;           /* menos extremo para que se vea */
  width: min(30vw, 210px);
  transform: rotate(12deg);
  opacity: 0.38;
  z-index: 8;             /* ENCIMA de todo */
  pointer-events: none;    /* no interfiere */
}
.rama-der-baja6{
  position: absolute;      /* 🔥 CLAVE */
  top: -60px;                 /* o ajusta según quieras: top / bottom */
  left: -70px;           /* menos extremo para que se vea */
  width: min(30vw, 210px);
  transform: rotate(12deg);
  opacity: 0.38;
  z-index: 8;             /* ENCIMA de todo */
  pointer-events: none;    /* no interfiere */
}

</style>